import { cast } from 'redpoints-front-common/helpers';

import FilterByEnum from '../enumerations/FilterBy';

export const filtersCastOptions = {
  domainId: cast.arrayFromSingleValue(cast.number),
  domainPlatformId: cast.arrayFromSingleValue(cast.number),
  filterBy: filterBy => cast.enum(FilterByEnum)(filterBy),
};

export const DOMAINS_PLATFORMS_TREE_PARENT_KEY = 'domainPlatformId';
export const DOMAINS_PLATFORMS_TREE_CHILDREN_KEY = 'domainId';
